import CountryContent from './CountryContent'

export default CountryContent
